const locale = {
	devices: 'Devices',
	companies:'Companies',
};

export default locale;
